import { PaymentTerm, Order, IProduct } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';

export enum OneClickPaymentsActionTypes {
  LOAD_PAYMENTS = '[One Click] Load payments',
  LOAD_PAYMENTS_COMPLETE = '[One Click] Load payments completed',
  LOAD_PAYMENTS_BUILDER_PRODUCT = '[One Click] Load payments from builder product',
  SELECT_PAYMENT = '[One Click] Select payments',
  RESET = '[One Click] payments reset',
}

export class OneClickLoadPaymentsFromBuilderProductAction implements Action {
  readonly type = OneClickPaymentsActionTypes.LOAD_PAYMENTS_BUILDER_PRODUCT;

  constructor(public payload: IProduct, public index: number) {}
}

export class OneClickLoadPaymentsAction implements Action {
  readonly type = OneClickPaymentsActionTypes.LOAD_PAYMENTS;

  constructor(public payload: Order) {}
}

export class OneClickLoadPaymentsCompleteAction implements Action {
  readonly type = OneClickPaymentsActionTypes.LOAD_PAYMENTS_COMPLETE;

  constructor(public payload: PaymentTerm[], public index: number) {}
}

export class OneClickSelectPaymentsAction implements Action {
  readonly type = OneClickPaymentsActionTypes.SELECT_PAYMENT;

  constructor(public payload: PaymentTerm, public index: number) {}
}

export class OneClickResetPaymentsAction implements Action {
  readonly type = OneClickPaymentsActionTypes.RESET;

  constructor() {}
}

export type OneClickPaymentsActions =
  | OneClickLoadPaymentsFromBuilderProductAction
  | OneClickLoadPaymentsAction
  | OneClickLoadPaymentsCompleteAction
  | OneClickSelectPaymentsAction
  | OneClickResetPaymentsAction;
